module.exports = __webpack_public_path__ + "static/media/Xiaomi Mi Mix Alpha Front.44ccc316.png";